import {FC} from 'react'

import './style.css'

type Props = {
  dataPana: any
}

const DocumentContent: FC<Props> = ({dataPana}) => {
  return (
    <div>
      <div className='row'>
        <p className='h6 mt-5'>Prioritas 1</p>
        <div className='col-md-6'>
          {dataPana?.file_proposal_prioritas_1?.file ? (
            <>
              <p className='h6 mb-3 mt-5'>
                Proposal <i className='text-danger'>*</i>
              </p>
              <a
                href={dataPana?.file_proposal_prioritas_1?.file}
                style={{color: '#575757'}}
                target='__blank'
              >
                <div
                  className='d-flex justify-content-between border rounded p-4 mt-4'
                  style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
                >
                  <p className='fw-bold'>
                    <i className='fa fa-file-alt text-black' /> File Proposal
                  </p>
                </div>
              </a>
            </>
          ) : null}
        </div>
        <div className='col-md-6'>
          {dataPana?.file_Ppt_prioritas_1?.file ? (
            <>
              <p className='h6 mb-3 mt-5'>
                PPT <i className='text-danger'>*</i>
              </p>
              <a
                href={dataPana?.file_Ppt_prioritas_1?.file}
                style={{color: '#575757'}}
                target='__blank'
              >
                <div
                  className='d-flex justify-content-between border rounded p-4 mt-4'
                  style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
                >
                  <p className='fw-bold'>
                    <i className='fa fa-file-alt text-black' /> File BAHAN PRESENTASI
                  </p>
                </div>
              </a>
            </>
          ) : null}
        </div>

        {dataPana?.tipe == 'kelompok' ? (
          <>
            <p className='h6 mt-10'>Prioritas 2</p>
            <div className='col-md-6'>
              {dataPana?.file_proposal_prioritas_2?.file ? (
                <>
                  <p className='h6 mb-3 mt-5'>
                    Proposal <i className='text-danger'>*</i>
                  </p>
                  <a
                    href={dataPana?.file_proposal_prioritas_2?.file}
                    style={{color: '#575757'}}
                    target='__blank'
                  >
                    <div
                      className='d-flex justify-content-between border rounded p-4 mt-4'
                      style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
                    >
                      <p className='fw-bold'>
                        <i className='fa fa-file-alt text-black' /> File Proposal
                      </p>
                    </div>
                  </a>
                </>
              ) : null}
            </div>
            <div className='col-md-6'>
              {dataPana?.file_Ppt_prioritas_2?.file ? (
                <>
                  <p className='h6 mb-3 mt-5'>
                    PPT <i className='text-danger'>*</i>
                  </p>
                  <a
                    href={dataPana?.file_Ppt_prioritas_2?.file}
                    style={{color: '#575757'}}
                    target='__blank'
                  >
                    <div
                      className='d-flex justify-content-between border rounded p-4 mt-4'
                      style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
                    >
                      <p className='fw-bold'>
                        <i className='fa fa-file-alt text-black' /> File PPT
                      </p>
                    </div>
                  </a>
                </>
              ) : null}
            </div>
          </>
        ) : null}
      </div>

      {dataPana?.fileKesehatan?.file ? (
        <>
          <p className='h6 mb-3 mt-10'>
            Surat Keterangan Sehat <i className='text-danger'>*</i>
          </p>
          <a href={dataPana?.fileKesehatan?.file} style={{color: '#575757'}} target='__blank'>
            <div
              className='d-flex justify-content-between border rounded p-4 mt-4'
              style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
            >
              <p className='fw-bold'>
                <i className='fa fa-file-alt text-black' /> File Surat Keterangan Sehat
              </p>
            </div>
          </a>
        </>
      ) : null}

      {dataPana?.fileKerja?.file ? (
        <>
          <p className='h6 mb-3 mt-10'>
            Surat Keterangan Izin dari Tempat Kerja <i className='text-danger'>*</i>
          </p>
          <a href={dataPana?.fileKerja?.file} style={{color: '#575757'}} target='__blank'>
            <div
              className='d-flex justify-content-between border rounded p-4 mt-4'
              style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
            >
              <p className='fw-bold'>
                <i className='fa fa-file-alt text-black' /> File Surat Keterangan Izin dari Tempat
                Kerja
              </p>
            </div>
          </a>
        </>
      ) : null}

      {dataPana?.fileKomitmen?.file ? (
        <>
          <p className='h6 mb-3 mt-10'>
            Surat Pernyataan <i className='text-danger'>*</i>
          </p>
          <a href={dataPana?.fileKomitmen?.file} style={{color: '#575757'}} target='__blank'>
            <div
              className='d-flex justify-content-between border rounded p-4 mt-4'
              style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
            >
              <p className='fw-bold'>
                <i className='fa fa-file-alt text-black' /> File Surat Pernyataan
              </p>
            </div>
          </a>
        </>
      ) : null}
    </div>
  )
}

const Document: FC<Props> = ({dataPana}) => {
  return <DocumentContent dataPana={dataPana} />
}

export default Document
